import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
    Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
    Tooltip, TooltipContent, TooltipProvider, TooltipTrigger
} from "@/components/ui";
import { languages } from "@/config/languages";
import { setCookie } from "@/utils/cookies";

type LanguageSwitcherProps = {
    variant?: 'select' | 'icon';
};

export function LanguageSwitcher({ variant = 'select' }: LanguageSwitcherProps) {
    const { i18n, t } = useTranslation();

    const handleLanguageChange = (value: string) => {
        i18n.changeLanguage(value);
        setCookie("language", value);
    };

    if (variant === 'icon') {
        return (
            <TooltipProvider>
                <DropdownMenu>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" size="icon">
                                    <Languages className="h-5 w-5" strokeWidth={1.5} />
                                </Button>
                            </DropdownMenuTrigger>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t("common.selectLanguage")}</p>
                        </TooltipContent>
                    </Tooltip>
                    <DropdownMenuContent align="end">
                        {languages.map((lang) => (
                            <DropdownMenuItem
                                key={lang.code}
                                onClick={() => handleLanguageChange(lang.code)}
                                className={i18n.language === lang.code ? "bg-accent" : ""}
                            >
                                {lang.name}
                            </DropdownMenuItem>
                        ))}
                    </DropdownMenuContent>
                </DropdownMenu>
            </TooltipProvider>
        );
    }

    return (
        <Select
            value={i18n.language}
            onValueChange={handleLanguageChange}
        >
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder={t("common.selectLanguage")} />
            </SelectTrigger>
            <SelectContent>
                {languages.map((lang) => (
                    <SelectItem key={lang.code} value={lang.code}>
                        {lang.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
} 